import { connect } from 'react-redux';

import { Tree } from 'src/components/organisms/Filter/components/FilterOptions/Tree';
import {
  selectChildNodes,
  selectParentNodes,
  selectRouterPathWithoutCurrentFilter,
} from 'src/components/organisms/Filter/modules/selectors/treeSelectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { TreeContainerOwnProps, TreeContainerStateProps } from './TreeContainer.types';

export const mapStateToProps = (
  state: ReduxApplicationState,
  ownProps: TreeContainerOwnProps,
): TreeContainerStateProps => ({
  // @ts-ignore
  childNodes: selectChildNodes(state, ownProps),
  parentNodes: selectParentNodes(state, ownProps),
  // @ts-ignore
  pathWithoutCurrentFilter: selectRouterPathWithoutCurrentFilter(state, ownProps),
});

export const TreeContainer = connect(mapStateToProps)(Tree);
